function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { params, bool as boolType, shape as shapeType, string as stringType, useDataModel } from '@thd-nucleus/data-sources';
import { useStoreId } from '@thd-nucleus/experience-context';
const ruleMap = {
  isHDPPSku: {
    expectedValue: 'hdpp'
  }
};
export function withSkuClassificationRule(BaseComponent) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  function SkuClassificationRule(props) {
    const {
      renderRules: renderRulesProp = [],
      propRules: propRulesProp = {},
      itemId
    } = props;
    const storeId = useStoreId();
    const {
      data: productData
    } = useDataModel('clientOnlyProduct', {
      variables: {
        itemId,
        storeId
      },
      skip: !itemId,
      ssr: false
    });
    const renderRules = [...renderRulesProp];
    const propRules = _objectSpread({}, propRulesProp);
    if (!productData) {
      return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, props, {
        renderRules: renderRules,
        propRules: propRules
      }));
    }
    if (opts.render) {
      var _productData$product, _productData$product$;
      const mappedRule = ruleMap[opts.render.name];
      const matchedValue = (productData === null || productData === void 0 ? void 0 : (_productData$product = productData.product) === null || _productData$product === void 0 ? void 0 : (_productData$product$ = _productData$product.identifiers) === null || _productData$product$ === void 0 ? void 0 : _productData$product$.skuClassification) === mappedRule.expectedValue;
      renderRules.push(opts.render.negate ? !matchedValue : matchedValue);
    }
    if (opts.prop) {
      var _productData$product2, _productData$product3;
      const mappedRule = ruleMap[opts.prop.name];
      const matchedValue = (productData === null || productData === void 0 ? void 0 : (_productData$product2 = productData.product) === null || _productData$product2 === void 0 ? void 0 : (_productData$product3 = _productData$product2.identifiers) === null || _productData$product3 === void 0 ? void 0 : _productData$product3.skuClassification) === mappedRule.expectedValue;
      propRules[opts.prop.alias || opts.prop.name] = opts.prop.negate ? !matchedValue : matchedValue;
    }
    return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, props, {
      renderRules: renderRules,
      propRules: propRules
    }));
  }
  SkuClassificationRule.displayName = 'SkuClassificationRule';
  SkuClassificationRule.dataModel = {
    clientOnlyProduct: params({
      itemId: stringType().isRequired()
    }).shape({
      identifiers: shapeType({
        skuClassification: stringType()
      })
    })
  };
  return SkuClassificationRule;
}
//# sourceMappingURL=withSkuClassificationRule.js.map